import {
	type UseTitleGenerationOnPasteProps,
	useTitleGenerationOnPaste,
} from './hooks/useTitleGenerationOnPaste.tsx';

export const TitleGenerationOnPaste = ({
	contentId,
	textAreaRef,
	title,
	isLivePage,
	isEditorEmpty,
	userOffline,
	flags,
	i18n,
	formatMessage,
}: UseTitleGenerationOnPasteProps) => {
	useTitleGenerationOnPaste({
		contentId,
		textAreaRef,
		title,
		isLivePage,
		isEditorEmpty,
		userOffline,
		flags,
		i18n,
		formatMessage,
	});

	return null;
};
